/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_Eb1_Point_1_TextInputs */

const en_visa_eb1_point_1_text = /** @type {(inputs: Visa_Eb1_Point_1_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EB-1 may be available through different tracks, including accomplishment-based, research-focused, and multinational leadership cases, depending on the facts.`)
};

const pt_visa_eb1_point_1_text = /** @type {(inputs: Visa_Eb1_Point_1_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O EB-1 pode estar disponível por diferentes vias, incluindo casos baseados em realizações, pesquisa e liderança multinacional, dependendo dos fatos.`)
};

const es_visa_eb1_point_1_text = /** @type {(inputs: Visa_Eb1_Point_1_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El EB-1 puede estar disponible a través de diferentes vías, incluyendo casos basados en logros, investigación y liderazgo multinacional, según los hechos.`)
};

/**
* | output |
* | --- |
* | "EB-1 may be available through different tracks, including accomplishment-based, research-focused, and multinational leadership cases, depending on the facts." |
*
* @param {Visa_Eb1_Point_1_TextInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_eb1_point_1_text = /** @type {((inputs?: Visa_Eb1_Point_1_TextInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_Eb1_Point_1_TextInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_eb1_point_1_text(inputs)
	if (locale === "es") return es_visa_eb1_point_1_text(inputs)
	return en_visa_eb1_point_1_text(inputs)
});